import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'filterByValue'
})

export class FilterByValuePipe implements PipeTransform {
  transform<T extends { value: unknown }>(items: T[]): T[] {
    if (!items) {
      return [];
    }
    return items.filter(item => item.value);
  }
}
